// extracted by mini-css-extract-plugin
export default {"zoomModal":"a5-z"};